import { useState } from "react";
import axiosInstance from "../../utils/axios-instance";
import Button from "../button/Button";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import UseAuth from "../../utils/use-auth";
import clsx from "clsx";

const PaymentSettings = () => {
  const navigate = useNavigate();
  const { user } = UseAuth();
  const [loading, setLoading] = useState(false);

  const CancelSubscription = async () => {
    setLoading(true);
    try {
      await axiosInstance.post("/payment/stripe/cancel-subscription");
      navigate("/pricing?message=Subscription Cancelled Successfully");
      toast.success("Subscription Cancelled Successfully");
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <div className="w-[92%] md:w-[60%] lg:w-[50%] mx-auto py-12">
      {user?.subscription ? (
        <div className="w-full bg-white border border-gray-100 rounded-3xl p-8 shadow-soft">
          <div className="w-full flex items-start justify-between gap-6 flex-col md:flex-row">
            <div>
              <p className="text-xs text-gray-500 uppercase tracking-wider font-medium m-0">
                Current Plan ({user?.subscription?.plan}){" "}
                <span
                  className={clsx(
                    "ml-1 px-2 py-0.5 rounded-full text-[10px] font-medium",
                    user?.subscription?.status === "paid"
                      ? "bg-green-50 text-green-600"
                      : "bg-red-50 text-red-600"
                  )}
                >
                  {user?.subscription?.status}
                </span>
              </p>
              <h2 className="font-display text-3xl text-blue font-semibold mt-2 capitalize tracking-tight">
                {user?.subscription?.type}
              </h2>
            </div>
            <div className="md:text-end">
              <p className="text-xs text-gray-500 uppercase tracking-wider">Total users</p>
              <h2 className="font-display text-2xl text-lightBlack font-semibold mt-1">
                {user?.subscription?.totalUsers}+
              </h2>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-100">
            <div className="w-full md:w-auto">
              <Button
                isLoading={loading}
                disabled={loading}
                className="!bg-red-50 !text-red-600 !border !border-red-100 hover:!bg-red-100 !w-full md:!w-auto !px-6"
                variant="secondary"
                onClick={CancelSubscription}
              >
                {user?.subscription?.status === "paid"
                  ? "Cancel Subscription"
                  : "Unsubscribe"}
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full bg-white border border-gray-100 rounded-3xl p-10 text-center shadow-soft">
          <h2 className="font-display text-2xl text-lightBlack font-semibold capitalize">
            No Active Subscription
          </h2>
          <p className="text-sm text-gray-500 mt-2 mb-6">Subscribe to unlock the full power of Coach AI.</p>
          <div className="w-full md:w-auto inline-block">
            <Button onClick={() => navigate("/pricing")} className="!w-full md:!w-auto !px-8">View Plans</Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentSettings;
